"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProducerClient_1 = require("./ProducerClient");
const ConsumerClient_1 = require("./ConsumerClient");
const events_1 = require("events");
const Logger_1 = __importDefault(require("./Logger"));
class StreamingHelper extends events_1.EventEmitter {
    constructor({ consumerOnAllStreamClosed } = {}) {
        super();
        this.logger = new Logger_1.default();
        this.loggerContext = this._loggerContext.bind(this);
        this.statisticHistory = {
            consumer: {
                rtcStatsChanges: [],
                connectionStateChanges: []
            },
            producer: {
                rtcStatsChanges: [],
                connectionStateChanges: []
            }
        };
        if (consumerOnAllStreamClosed) {
            this.consumerOnAllStreamClosed = consumerOnAllStreamClosed;
        }
        this.webRTCData = StreamingHelper.getInitData();
    }
    static getStreamFromNavigator(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const media = yield navigator.mediaDevices.getUserMedia(options);
            return new MediaStream(media.getTracks());
        });
    }
    static getInitData() {
        return {
            producer: {
                client: null,
                stream: new MediaStream([])
            },
            consumer: {
                client: null,
                connection: null
            }
        };
    }
    static connectionsEquals(first, second) {
        if (first.consumerUrl) {
            return first.consumerUrl === second.consumerUrl &&
                first.userKey === second.userKey &&
                first.opponentKey === second.opponentKey;
        }
        else {
            return first.producerUrl === second.producerUrl &&
                first.userKey === second.userKey;
        }
    }
    static isOtherDevice(deviceId, constraint) {
        if (constraint === false)
            return false;
        if (deviceId === constraint)
            return false;
        if (deviceId && constraint === true)
            return false;
        if (typeof (constraint) !== "boolean" && constraint.deviceId) {
            if (deviceId === constraint.deviceId)
                return false;
            if (typeof (constraint.deviceId) === "object") {
                const c = constraint.deviceId;
                if (deviceId === c.exact)
                    return false;
                if (deviceId === c.ideal)
                    return false;
            }
        }
        return true;
    }
    getDeviceList() {
        return __awaiter(this, void 0, void 0, function* () {
            const media = yield navigator.mediaDevices.enumerateDevices();
            const audioInputList = media.filter(device => device.kind === "audioinput");
            const videoInputList = media.filter(device => device.kind === "videoinput");
            return { audioInputList, videoInputList };
        });
    }
    getCurrentStreamTracksStatus() {
        var _a, _b;
        const audioDeviceId = ((_a = this.webRTCData.producer.stream.getAudioTracks()[0]) === null || _a === void 0 ? void 0 : _a.getSettings().deviceId) || false;
        const videoDeviceId = ((_b = this.webRTCData.producer.stream.getVideoTracks()[0]) === null || _b === void 0 ? void 0 : _b.getSettings().deviceId) || false;
        return {
            audioDeviceId,
            videoDeviceId
        };
    }
    getStream(options = { video: true, audio: true }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const streamToProduce = new MediaStream();
            const { audioDeviceId, videoDeviceId } = this.getCurrentStreamTracksStatus();
            if (!videoDeviceId && !audioDeviceId) {
                (yield StreamingHelper.getStreamFromNavigator(options)).getTracks().forEach(t => streamToProduce.addTrack(t));
            }
            else {
                if ((!videoDeviceId && options.video) || StreamingHelper.isOtherDevice(videoDeviceId, (_a = options.video) !== null && _a !== void 0 ? _a : false)) {
                    (yield StreamingHelper.getStreamFromNavigator({ audio: false, video: options.video }))
                        .getTracks()
                        .forEach(t => streamToProduce.addTrack(t));
                }
                if ((!audioDeviceId && options.audio) || StreamingHelper.isOtherDevice(audioDeviceId, (_b = options.audio) !== null && _b !== void 0 ? _b : false)) {
                    (yield StreamingHelper.getStreamFromNavigator({ audio: options.audio, video: false }))
                        .getTracks()
                        .forEach(t => streamToProduce.addTrack(t));
                }
                if (streamToProduce.getVideoTracks().length === 0 && options.video) {
                    this.webRTCData.producer.stream.getVideoTracks().forEach(t => streamToProduce.addTrack(t));
                }
                if (streamToProduce.getAudioTracks().length === 0 && options.audio) {
                    this.webRTCData.producer.stream.getAudioTracks().forEach(t => streamToProduce.addTrack(t));
                }
            }
            return streamToProduce;
        });
    }
    static filterSignificantStats(stats) {
        const extract = (obj, props) => {
            return props.reduce((res, prop) => { if (obj[prop] !== undefined)
                res[prop] = obj[prop]; return res; }, {});
        };
        return stats
            .filter(s => !["certificate", "codec", "stream", "peer-connection", "remote-inbound-rtp"].includes(s.type))
            .map((s) => {
            switch (s.type) {
                case "media-source": return extract(s, ["type", "kind", "audioLevel", "width", "height", "framesPerSecond"]);
                case "data-channel": return extract(s, ["type", "state", "bytesSent", "bytesReceived"]);
                case "candidate-pair": return extract(s, ["type", "state", "nominated", "bytesSent", "bytesReceived"]);
                case "local-candidate":
                case "remote-candidate":
                    return extract(s, ["type", "ip", "port", "isRemote", "protocol"]);
                case "track": return extract(s, ["type", "kind", "ended", "audioLevel", "frameWidth", "frameHeight", "framesSent", "remoteSource"]);
                case "outbound-rtp": return extract(s, ["type", "kind", "bytesSent", "frameWidth", "frameHeight"]);
                case "inbound-rtp": return extract(s, ["type", "kind", "codecId", "bytesReceived", "packetsLost", "framesDecoded", "framesDropped"]);
                case "transport": return extract(s, ["type", "dtlsState", "bytesSent", "bytesReceived"]);
                default: return extract(s, ["type"]);
            }
        }).filter(s => s !== undefined);
    }
    static collectRTCStats(client, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const stats = StreamingHelper.filterSignificantStats(yield client.getStats());
                changes.push({
                    stats, utcTime: new Date().getTime()
                });
                if (changes.length > 100)
                    changes.shift();
            }
            catch (e) { }
        });
    }
    produceStream(connection, options = { video: true, audio: true }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!connection.producerUrl) {
                throw new Error("producerUrl are required");
            }
            let resultStream;
            if (options instanceof MediaStream) {
                resultStream = options;
            }
            else {
                resultStream = yield this.getStream(options);
            }
            if (!this.webRTCData.producer.client) {
                this.webRTCData.producer.client = new ProducerClient_1.ProducerClient(connection.producerUrl, connection.userKey, this.logger);
                let rtcStatsCollectorTimer = null;
                this.webRTCData.producer.client.on("close", data => {
                    this.logger.log("[STREAMING HELPER] - producer on.close", Object.assign(Object.assign({}, this.loggerContext()), { history: this.getStatisticHistory() }));
                    this.emit("close", { type: "producer", data });
                    if (rtcStatsCollectorTimer)
                        clearTimeout(rtcStatsCollectorTimer);
                });
                this.webRTCData.producer.client.on("connectionstatechange", state => {
                    this.logger.log("[STREAMING HELPER] - producer connectionstatechange " + state, Object.assign(Object.assign({}, this.loggerContext()), { history: this.getStatisticHistory() }));
                    this.emit("connectionstatechange", state);
                    this.statisticHistory.producer.connectionStateChanges.push({ state, utcTime: new Date().getTime() });
                });
                const collect = () => __awaiter(this, void 0, void 0, function* () {
                    yield StreamingHelper.collectRTCStats(this.webRTCData.producer.client, this.statisticHistory.producer.rtcStatsChanges);
                    rtcStatsCollectorTimer = setTimeout(collect, 250);
                });
                collect().then();
            }
            const client = this.webRTCData.producer.client;
            this.webRTCData.producer.stream.getTracks().filter(t => resultStream.getTrackById(t.id) === null)
                .forEach(t => this.webRTCData.producer.stream.removeTrack(t));
            yield client.produceStream(resultStream.getTracks());
            this.webRTCData.producer = {
                client,
                stream: resultStream
            };
            return resultStream;
        });
    }
    consumeStream({ connection, tracks = { video: true, audio: true }, onData }) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log("[STREAMING HELPER] - consumeStream", this.loggerContext());
            if (!connection.consumerUrl || !connection.opponentKey) {
                throw new Error("consumerUrl and opponentKey are required");
            }
            if (this.webRTCData.consumer.connection && !StreamingHelper.connectionsEquals(this.webRTCData.consumer.connection, connection)) {
                this.closeAllStreams();
            }
            if (!this.webRTCData.consumer.client) {
                this.webRTCData.consumer.client = new ConsumerClient_1.ConsumerClient(connection.consumerUrl, connection.userKey, connection.opponentKey, this.logger);
                this.webRTCData.consumer.client.on("data", onData !== null && onData !== void 0 ? onData : (() => { }));
                if (this.consumerOnAllStreamClosed) {
                    this.webRTCData.consumer.client.on("allStreamsClosed", () => {
                        this.logger.log("[STREAMING HELPER] - on.allStreamsClosed", this.loggerContext());
                        this.consumerOnAllStreamClosed && this.consumerOnAllStreamClosed();
                    });
                }
                this.webRTCData.consumer.client.on("producers-updated", data => this.emit("producers-updated", data));
                let rtcStatsCollectorTimer = null;
                this.webRTCData.consumer.client.on("close", data => {
                    this.logger.log("[STREAMING HELPER] - consumer on.close", Object.assign(Object.assign({}, this.loggerContext()), { history: this.getStatisticHistory() }));
                    this.emit("close", { type: "consumer", data });
                    if (rtcStatsCollectorTimer)
                        clearTimeout(rtcStatsCollectorTimer);
                });
                this.webRTCData.consumer.client.on("connectionstatechange", state => {
                    this.emit("connectionstatechange", state);
                    this.logger.log("[STREAMING HELPER] - consumer connectionstatechange " + state, Object.assign(Object.assign({}, this.loggerContext()), { history: this.getStatisticHistory() }));
                    this.statisticHistory.consumer.connectionStateChanges.push({ state, utcTime: new Date().getTime() });
                });
                const collect = () => __awaiter(this, void 0, void 0, function* () {
                    yield StreamingHelper.collectRTCStats(this.webRTCData.consumer.client, this.statisticHistory.consumer.rtcStatsChanges);
                    rtcStatsCollectorTimer = setTimeout(collect, 250);
                });
                collect().then();
            }
            const client = this.webRTCData.consumer.client;
            const stream = yield client.consumeStream({ tracks });
            this.webRTCData.consumer = {
                client,
                connection
            };
            this.webRTCData.consumer.client = client;
            return stream;
        });
    }
    closeAllStreams() {
        this.webRTCData.producer.stream.getTracks().forEach(t => {
            t.stop();
            this.webRTCData.producer.stream.removeTrack(t);
        });
        this.webRTCData.consumer.client && this.webRTCData.consumer.client.close(new Error("closeAllStreams called"));
        this.webRTCData.producer.client && this.webRTCData.producer.client.close(new Error("closeAllStreams called"));
        const resetData = StreamingHelper.getInitData();
        Reflect.ownKeys(this.webRTCData).forEach(k => {
            this.webRTCData[k] = resetData[k];
        });
    }
    getStatisticHistory(maxStatRecords = 20) {
        if (maxStatRecords === Infinity)
            return this.statisticHistory;
        return {
            consumer: {
                connectionStateChanges: this.statisticHistory.consumer.connectionStateChanges,
                rtcStatsChanges: this.statisticHistory.consumer.rtcStatsChanges.map(c => ({
                    utcTime: c.utcTime,
                    stats: StreamingHelper.filterSignificantStats(c.stats)
                })).slice(-maxStatRecords)
            },
            producer: {
                connectionStateChanges: this.statisticHistory.producer.connectionStateChanges,
                rtcStatsChanges: this.statisticHistory.producer.rtcStatsChanges.map(c => ({
                    utcTime: c.utcTime,
                    stats: StreamingHelper.filterSignificantStats(c.stats)
                })).slice(-maxStatRecords)
            }
        };
    }
    _loggerContext() {
        return this.webRTCData;
    }
}
exports.StreamingHelper = StreamingHelper;
